<template>
  <div class="transform-prompt-panel">
    <loading type="spinner" vertical>{{ transformTitle }}</loading>
  </div>
</template>

<script>
import { Loading } from 'vant'
export default {
  name: 'TransformPromptPanel',
  props: {
    transformTitle: {
      type: String,
      default: '正在上传中，请等待上传完成再点击播放'
    }
  },
  components: {
    Loading
  }
}
</script>

<style lang="less" scoped>
.transform-prompt-panel {
  display: flex;
  justify-content: center;
  align-items: center;
  background: black;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/course/components/TransformPromptPanel.vue